import { request } from 'utils';

export const queryRechargeTx = (txId: string) => {
  const queryPath = '/wallet/recharge';
  return request.get<{ success: boolean }>(queryPath, {
    tx_id: txId,
  });
};
